import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { Node, Cluster, NodeDrainConfig } from '@cast/types';

import { getNodeQueryKey, getNodesQueryKey } from 'hooks/queries/nodes';

export const useDrainNodeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      nodeId,
      clusterId,
      config = {},
    }: {
      nodeId: NonNullable<Node['id']>;
      clusterId: Cluster['id'];
      config?: NodeDrainConfig;
    }) => {
      return apiClient.clusters.drainNode({
        clusterId: clusterId,
        nodeId: nodeId,
        config: config,
      });
    },
    onSuccess: (_, { nodeId, clusterId }) => {
      queryClient.invalidateQueries({
        queryKey: getNodesQueryKey({ clusterId }),
      });
      queryClient.invalidateQueries({
        queryKey: getNodeQueryKey({ clusterId, nodeId }),
      });
      notify.success('Node draining initiated successfully');
    },
    onError: (error) => {
      notify.error(parseApiError(error, 'Failed to initiate node draining'));
    },
  });
};
